var ZOOM_MAX = 5;
var ZOOM_MIN = 0.25;
var ZOOM_SPEED = 0.998;
var ZOOM_MAX_INPUT_NUMBER = 99999;

var ART_BOARD_OFFSETS = {
  top: 100,
  left: 50,
  right: 50,
  bottom: 100
};
var PAGES_GAP = 52;

// IMAGE LAYER
var ADJUST_GRAPH_NAME = 'adjust_tools.json';
var HSL_GRAPH_NAME = 'hsl_tool.json';
var PRIORITY; // TEXT LAYER

(function (PRIORITY) {
  PRIORITY["low"] = "low";
  PRIORITY["high"] = "high";
})(PRIORITY || (PRIORITY = {}));

var TEXT_STROKE_RATIO = 0.3; // Text max stroke width vs Text font size ratio

var LINE_DIVIDER = '\n'; // COLOR_LAYER

var DEFAULT_COLOR = {
  r: 255,
  g: 255,
  b: 255
};
var DEFAULT_SHADOW_COLOR = {
  r: 0,
  g: 0,
  b: 0
}; // VECTOR LAYER

var FLOAT_INT_REGEXP_PATTERN = '-?\\d*\\.?\\d+(e[+-]?\\d*)?'; // conditional minus symbol,
// digit, 0 or more times
// conditional dot
// digit, at least 1 or more times
// conditional e +- exp. numbers
// digit 0 or more times

var FLOAT_INT_REGEXP = new RegExp("".concat(FLOAT_INT_REGEXP_PATTERN), 'g');
var SVG_COMMAND_REG_EXP = new RegExp("[MLHVCSQTAZ]( *".concat(FLOAT_INT_REGEXP_PATTERN, " *,?)*"), 'gi');
var FLOAT_INT_PAIR_REGEXP = new RegExp("".concat(FLOAT_INT_REGEXP_PATTERN, " *,?").concat(FLOAT_INT_REGEXP_PATTERN), 'g');
var MARKER_REG_EX = /[MLSQHVCTAZ]/gi;
var DEFAULT_BLACK = '#000000';
var TRANSPARENT_RGBA = 'rgba(255, 255, 255, 0)';
var HUNDRED_PERCENT = 100;
var RANGE_MIN_VALUE = -100;
var RANGE_MAX_VALUE = 100;
var CONTRAST_MIN_VALUE = 60;
var CONTRAST_MAX_VALUE = 140;
var DEFAULT_OUTLINE_STROKE_WIDTH = 0; // 50 for now placeholder value,
// we need performance tests to define max path count

var MAX_PATH_VALUE = 50; // numbers is chosen as big as possible

var BIG_RECT = {
  x: 0,
  y: 0,
  width: 9000,
  height: 9000
};
var SVG_ABSOLUTE_MARKERS;

(function (SVG_ABSOLUTE_MARKERS) {
  SVG_ABSOLUTE_MARKERS["M"] = "M";
  SVG_ABSOLUTE_MARKERS["L"] = "L";
  SVG_ABSOLUTE_MARKERS["C"] = "C";
  SVG_ABSOLUTE_MARKERS["S"] = "S";
  SVG_ABSOLUTE_MARKERS["Q"] = "Q";
  SVG_ABSOLUTE_MARKERS["H"] = "H";
  SVG_ABSOLUTE_MARKERS["V"] = "V";
  SVG_ABSOLUTE_MARKERS["T"] = "T";
  SVG_ABSOLUTE_MARKERS["A"] = "A";
  SVG_ABSOLUTE_MARKERS["Z"] = "Z";
})(SVG_ABSOLUTE_MARKERS || (SVG_ABSOLUTE_MARKERS = {}));

var SVG_RELATIVE_MARKERS;

(function (SVG_RELATIVE_MARKERS) {
  SVG_RELATIVE_MARKERS["m"] = "m";
  SVG_RELATIVE_MARKERS["l"] = "l";
  SVG_RELATIVE_MARKERS["c"] = "c";
  SVG_RELATIVE_MARKERS["s"] = "s";
  SVG_RELATIVE_MARKERS["q"] = "q";
  SVG_RELATIVE_MARKERS["h"] = "h";
  SVG_RELATIVE_MARKERS["v"] = "v";
  SVG_RELATIVE_MARKERS["t"] = "t";
  SVG_RELATIVE_MARKERS["a"] = "a";
  SVG_RELATIVE_MARKERS["z"] = "z";
})(SVG_RELATIVE_MARKERS || (SVG_RELATIVE_MARKERS = {}));

var COLOR_CHANNELS = ['r', 'g', 'b'];
// THIS ARE VERY BAAAD SHAPES

/* eslint-disable max-len */
var SPECIAL_SHAPES = {
  simple_14: {
    movePoints: {
      moveX: -13,
      moveY: -13
    },
    path: 'M0.5341720109675345,1.0130054825027726c-0.2761922770239871,0-0.5000000229196992-0.11315739247899026-0.5000000229196992-0.2528004498083482V0.2659008861859494C0.03417198804783524,0.12625782885659148,0.2579797339435474,0.013005505679212806,0.5341720109675345,0.013005505679212806  S1.0341720338872336,0.12616289815820309,1.0341720338872336,0.26580595548756103v0.4943041465084751C1.0341720338872336,0.899753159325394,0.8103642879915216,1.0130054825027726,0.5341720109675345,1.0130054825027726z'
  },
  simple_16: {
    movePoints: {
      moveX: -7,
      moveY: -9
    },
    path: 'M0.9659123412383716,0.8170299442848754c-0.020357921122071354-0.055734497297731125-0.026891393482177974-0.1156254655803778-0.01912697705422518-0.1740049898685097c0.0059653443287930015-0.020026632927320338,0.010699744589739829-0.0406200573525837,0.01391913676718367-0.061685808026132924c0.00018937601043787308-0.0005667914979430284,0.0007575040417514923-0.003306283738000999,0.0005681280313136192-0.00406200573525837  c0.0030300161670059693-0.021254681172863565,0.00463971225572789-0.04298168859401299,0.00463971225572789-0.0650865570137911s-0.001609696088721921-0.04383187584092753-0.00463971225572789-0.0650865570137911c0.00018937601043787308-0.0007557219972573713-0.00037875202087574617-0.003495214237315342-0.0005681280313136192-0.00406200573525837c-0.003219392177443842-0.021065750673549224-0.007859104433171733-0.04165917509881259-0.01391913676718367-0.061685808026132924  c-0.007764416427952795-0.05837952428813192-0.001230944067846175-0.11836495782043577,0.01912697705422518-0.1740049898685097c0.006060032334011939-0.016531418690004997,0.025660449414331803-0.05195588731144427,0.025660449414331803-0.05195588731144427c0.021778241200355403-0.021727007421149424,0.021778241200355403-0.057057010792931524,0-0.07878401821408096l-0.04819619465643869-0.04808281207550024c-0.006817536375763431-0.006801497975316341-0.014960704824591973-0.01152476045817491-0.023577313299515196-0.013980856949261367  c-0.019032289049006244-0.005667914979430284-0.040431778228485905-0.000944652496571714-0.055487171058296814,0.013980856949261367c0,0-0.0355080019571012,0.01945984142937731-0.05198371486519616,0.025505617407436277C0.7542846495740485,0.07472201247882257,0.6916958781243314,0.08105118420585306,0.631000866778993,0.07179358973945027c-0.015244768840248783-0.004250936234572713-0.030773601696154375-0.007651685222230883-0.04649181056249784-0.010296712212631683  c-0.0034087681878817153-0.0010391177462288855-0.013351008735870052-0.003117353238686656-0.014297888788059416-0.002172700742114942c-0.020357921122071354-0.0027394922400579705-0.041189282270237396-0.004250936234572713-0.06230470743406024-0.004250936234572713s-0.04194678631198888,0.001416978744857571-0.06230470743406024,0.004250936234572713c-0.0009468800521893653-0.000944652496571714-0.010889120600177701,0.0011335829958860567-0.014297888788059416,0.002172700742114942c-0.015812896871562402,0.002645026990400799-0.031341729727467994,0.006140241227716141-0.04649181056249784,0.010296712212631683  c-0.06060032334011938,0.009257594466402798-0.12328378279505535,0.0029284227393723133-0.18123284198904452-0.018137327934176908c-0.016570400913313892-0.00604577597805897-0.05198371486519616-0.025505617407436277-0.05198371486519616-0.025505617407436277C0.13654010352570647,0.013225134952003996,0.1150459263410079,0.008596337718802596,0.09610832529722058,0.014169787448575711c-0.008616608474923224,0.002550561740743628-0.016759776923751767,0.0071793589739450265-0.023577313299515196,0.013980856949261367l-0.04829088266165763,0.04817727732515741  c-0.021778241200355403,0.021727007421149424-0.021778241200355403,0.057057010792931524,0,0.07878401821408096c0,0,0.01960041708031986,0.035424468621439276,0.025660449414331803,0.05195588731144427c0.020357921122071354,0.055734497297731125,0.026891393482177974,0.1156254655803778,0.01912697705422518,0.1740049898685097c-0.0059653443287930015,0.020026632927320338-0.010699744589739829,0.0406200573525837-0.01391913676718367,0.061685808026132924c-0.00018937601043787308,0.0005667914979430284-0.0007575040417514923,0.003306283738000999-0.0005681280313136192,0.00406200573525837  c-0.0030300161670059693,0.021254681172863565-0.00463971225572789,0.04298168859401299-0.00463971225572789,0.0650865570137911s0.001609696088721921,0.04383187584092753,0.00463971225572789,0.0650865570137911c-0.00018937601043787308,0.0007557219972573713,0.00037875202087574617,0.003495214237315342,0.0005681280313136192,0.00406200573525837c0.003219392177443842,0.021065750673549224,0.007859104433171733,0.04165917509881259,0.01391913676718367,0.061685808026132924  c0.007764416427952795,0.05837952428813192,0.001230944067846175,0.11836495782043577-0.01912697705422518,0.1740049898685097c-0.006060032334011939,0.016531418690004997-0.025660449414331803,0.05195588731144427-0.025660449414331803,0.05195588731144427c-0.021778241200355403,0.021727007421149424-0.021778241200355403,0.057057010792931524,0,0.07878401821408096l0.04819619465643869,0.04808281207550024c0.006817536375763431,0.006801497975316341,0.014960704824591973,0.01152476045817491,0.023577313299515196,0.013980856949261367  c0.019032289049006244,0.005667914979430284,0.040431778228485905,0.000944652496571714,0.055487171058296814-0.013980856949261367c0,0,0.0355080019571012-0.01945984142937731,0.05198371486519616-0.025505617407436277c0.05794905919398916-0.021065750673549224,0.12063251864892514-0.027300457150922535,0.18123284198904452-0.018137327934176908c0.015244768840248783,0.004250936234572713,0.030773601696154375,0.007651685222230883,0.04649181056249784,0.010296712212631683  c0.0034087681878817153,0.0010391177462288855,0.013351008735870052,0.003117353238686656,0.014297888788059416,0.002172700742114942c0.020357921122071354,0.0027394922400579705,0.041189282270237396,0.004250936234572713,0.06230470743406024,0.004250936234572713s0.04194678631198888-0.001416978744857571,0.06230470743406024-0.004250936234572713c0.0009468800521893653,0.000944652496571714,0.010889120600177701-0.0011335829958860567,0.014297888788059416-0.002172700742114942c0.015812896871562402-0.002645026990400799,0.031341729727467994-0.006140241227716141,0.04649181056249784-0.010296712212631683  c0.06060032334011938-0.009257594466402798,0.12328378279505535-0.0029284227393723133,0.18123284198904452,0.018137327934176908c0.016570400913313892,0.00604577597805897,0.05198371486519616,0.025505617407436277,0.05198371486519616,0.025505617407436277c0.01505539282981091,0.015019974695490252,0.03645488200929056,0.019648771928691654,0.055487171058296814,0.013980856949261367c0.008616608474923224-0.002550561740743628,0.016759776923751767-0.0071793589739450265,0.023577313299515196-0.013980856949261367l0.04819619465643869-0.04808281207550024  c0.021778241200355403-0.021727007421149424,0.021778241200355403-0.057057010792931524,0-0.07878401821408096C0.9915727906527034,0.8689858315963197,0.9719723735723835,0.8335613629748804,0.9659123412383716,0.8170299442848754L0.9659123412383716,0.8170299442848754z'
  },
  organic_1: {
    movePoints: {
      moveX: -10,
      moveY: -10
    },
    path: 'm0 0.37780546985435276 0.13502309421406464-0.0110438185435973-0.05521530579863355 0.2333451982598784 0.12267974087000148-0.044353400279931086-0.08593235305179828 0.255432835347073 0.22698578783090137-0.044353400279931086-0.030717047253164736 0.09992874520900137 0.17177048203226783 0.0110438185435973-0.030717047253164736 0.12219450840173784 0.2515782704476989-0.0110438185435973 0.15339678812316623-0.11115068985814056 0.04909074116226634-0.03330958173633378-0.024498258545468807 0.12219450840173784h0.04909074116226634l0.04296617652589914-0.08888492666540407 0.024498258545468807-0.255432835347073-0.10430604696089989-0.02226576319273649 0.08593235305179828-0.3555397066616163-0.17798927073996376-0.05557534492907028s0.04296617652589914-0.17776985333080814 0.024498258545468807-0.15550409013807165-0.15933290461687596 0.09975061910345948-0.15933290461687596 0.09975061910345948l-0.030717047253164736-0.09992874520900137-0.1410534347791031 0.07784110812180677-0.030717047253164736-0.11115068985814056-0.12267974087000148 0.13323832694533513-0.06143409450632947-0.11097256375259866h-0.17177048203226783z'
  },
  organic_3: {
    movePoints: {
      moveX: -10,
      moveY: -8
    },
    path: 'M0.591326238157756 1.0049810401551191c-0.20486744888525282-0.2109104861659367-0.39729584383635047-0.3748488306065371-0.4966198047954381-0.4335175926033998S0.007727291080308524 0.16152475613060294 0.020166345014463707 0.11455261440526668 0.0822673794281627-0.014295869220754513 0.26847624741218273 0.009097371322298327s0.26696848329895184 0.15224172416907403 0.26696848329895184 0.15224172416907403c0.03100339957831103 0.1405451038975476 0.07454008834785417-0.011696620271526419 0.07454008834785417-0.011696620271526419s0.11176301489324279-0.08206200253991551 0.23587084846356388-0.09375862281144193 0.155205468405709 0.03508986081457925 0.16142499537278662 0.1288484836260212c0.006219526967077592 0.09375862281144193 0.024878107868310368 0.3631522103350107-0.1055434879261652 0.5036973142325584S0.591326238157756 1.0049810401551191 0.591326238157756 1.0049810401551191z'
  },
  decorative_12: {
    movePoints: {
      moveX: -10,
      moveY: -10
    },
    path: 'M0.46021765417170496 0.00977136916664341L0.18137847642079805 0.08329380707099915l0.45126964933494557 0.2419125376207834-0.3506650544135429 0.10682098720039299 0.2215235792019347 0.12930462304985404L0.009431680773881498 0.7132150815031567 0.6094316807738814 1.0097713923276936l0.2408706166868198-0.06346646575227613-0.4087061668681983-0.2170572102260206 0.4814993954050786-0.14856275839770464-0.24280532043530834-0.13091737330065925L1.0094316807738815 0.3197040203066824z'
  }
};

var Easing;

(function (Easing) {
  Easing["LINEAR"] = "linear";
  Easing["EASEINOUTCUBIC"] = "easeInOutCubic";
  Easing["EASEINQUINT"] = "easeInQuint";
  Easing["EASEINQUAD"] = "easeInQuad";
  Easing["EASEOUTQUAD"] = "easeOutQuad";
  Easing["EASEINCUBIC"] = "easeInCubic";
})(Easing || (Easing = {}));

var AnimationDirection;

(function (AnimationDirection) {
  AnimationDirection["Left"] = "left";
  AnimationDirection["Right"] = "right";
  AnimationDirection["Top"] = "top";
  AnimationDirection["Bottom"] = "bottom";
})(AnimationDirection || (AnimationDirection = {}));

var AnimationType;

(function (AnimationType) {
  AnimationType["Typing"] = "typing";
  AnimationType["Fade"] = "fade";
  AnimationType["Fly"] = "fly";
  AnimationType["Zoom"] = "zoom";
  AnimationType["Spin"] = "spin";
})(AnimationType || (AnimationType = {}));

var AnimationTimeDirection;

(function (AnimationTimeDirection) {
  AnimationTimeDirection["In"] = "in";
  AnimationTimeDirection["Out"] = "out";
})(AnimationTimeDirection || (AnimationTimeDirection = {}));

var AnimationNames;

(function (AnimationNames) {
  AnimationNames["FADE_IN"] = "fadeIn";
  AnimationNames["FADE_OUT"] = "fadeOut";
  AnimationNames["ZOOM_IN"] = "zoomIn";
  AnimationNames["ZOOM_OUT"] = "zoomOut";
  AnimationNames["SPIN"] = "spin";
  AnimationNames["FLY_IN_FROM_LEFT"] = "flyInFromLeft";
  AnimationNames["FLY_IN_FROM_RIGHT"] = "flyInFromRight";
  AnimationNames["FLY_IN_FROM_TOP"] = "flyInFromTop";
  AnimationNames["FLY_IN_FROM_BOTTOM"] = "flyInFromBottom";
  AnimationNames["FLY_OUT_TO_BOTTOM"] = "flyOutToBottom";
  AnimationNames["FLY_OUT_TO_TOP"] = "flyOutToTop";
  AnimationNames["FLY_OUT_TO_RIGHT"] = "flyOutToRight";
  AnimationNames["FLY_OUT_TO_LEFT"] = "flyOutToLeft";
  AnimationNames["TYPEWRITING"] = "typeWriting";
  AnimationNames["WORD_BY_WORD"] = "word by word";
  AnimationNames["LINE_BY_LINE"] = "line by line";
})(AnimationNames || (AnimationNames = {}));

var AnimationSettingsKeys;

(function (AnimationSettingsKeys) {
  AnimationSettingsKeys["Duration"] = "duration";
  AnimationSettingsKeys["Delay"] = "delay";
})(AnimationSettingsKeys || (AnimationSettingsKeys = {}));

var WORD_DIVIDER = ' ';
var CHAR_DIVIDER = '';
var AnimationPresetsNames;

(function (AnimationPresetsNames) {
  AnimationPresetsNames["SUPER_LFLY"] = "superLFly";
  AnimationPresetsNames["SUPER_RFLY"] = "superRFly";
  AnimationPresetsNames["SUPER_HI_FLY"] = "superHiFly";
  AnimationPresetsNames["SUPER_LO_FLY"] = "superLoFly";
  AnimationPresetsNames["ENLARGER"] = "enlarger";
  AnimationPresetsNames["ASCENDER"] = "ascender";
  AnimationPresetsNames["ALTERNATOR"] = "alternator";
  AnimationPresetsNames["DESCENDER"] = "descender";
  AnimationPresetsNames["SIDE_FLYER_HORIZONTAL"] = "sideFlyerHorizontal";
  AnimationPresetsNames["SIDE_FLYER_VERTICAL"] = "sideFlyerVertical";
  AnimationPresetsNames["LO_FLY_ZOOM"] = "loFlyZoom";
  AnimationPresetsNames["HI_FLY_ZOOM"] = "hiFlyZoom";
})(AnimationPresetsNames || (AnimationPresetsNames = {}));

var DEFAULT_TR = 'default-tr';
var DEFAULT_TR_ID = "#".concat(DEFAULT_TR);
var TRANSFORMER_BORDER_OFFSET = 0;
var TRANSFORMER_MIDDLE_ANCHOR_MAX = 32;
var TRANSFORMER_ANCHOR_SIZE = 12;
var TRANSFORMER_MIDDLE_ANCHOR_MIN = 8;
var TRANSFORMER_ROTATER_BOX_SIZE = 20;
var TRANSFORMER_ROTATER_BOX_SIZE_OFFSET = TRANSFORMER_ROTATER_BOX_SIZE / 2;
var Anchors;

(function (Anchors) {
  Anchors["TOP_LEFT"] = "top-left";
  Anchors["TOP_RIGHT"] = "top-right";
  Anchors["BOTTOM_LEFT"] = "bottom-left";
  Anchors["BOTTOM_RIGHT"] = "bottom-right";
  Anchors["MIDDLE_LEFT"] = "middle-left";
  Anchors["MIDDLE_RIGHT"] = "middle-right";
  Anchors["BOTTOM_CENTER"] = "bottom-center";
  Anchors["TOP_CENTER"] = "top-center";
})(Anchors || (Anchors = {}));

var ADJUST = 'adjust';
var MASK = 'mask';
var EFFECT = 'effect'; // subfolder

var WEB_EFFECTS = 'web-effects';
var DEFAULT_ADJUST = {
  name: 'adjust',
  settings: []
};

var isDev = process.env.NODE_ENV === 'development';
var isTest = process.env.NODE_ENV === 'testing';

export { ADJUST, ADJUST_GRAPH_NAME, ART_BOARD_OFFSETS, Anchors, AnimationDirection, AnimationNames, AnimationPresetsNames, AnimationSettingsKeys, AnimationTimeDirection, AnimationType, BIG_RECT, CHAR_DIVIDER, COLOR_CHANNELS, CONTRAST_MAX_VALUE, CONTRAST_MIN_VALUE, DEFAULT_ADJUST, DEFAULT_BLACK, DEFAULT_COLOR, DEFAULT_OUTLINE_STROKE_WIDTH, DEFAULT_SHADOW_COLOR, DEFAULT_TR, DEFAULT_TR_ID, EFFECT, Easing, FLOAT_INT_PAIR_REGEXP, FLOAT_INT_REGEXP, HSL_GRAPH_NAME, HUNDRED_PERCENT, LINE_DIVIDER, MARKER_REG_EX, MASK, MAX_PATH_VALUE, PAGES_GAP, PRIORITY, RANGE_MAX_VALUE, RANGE_MIN_VALUE, SPECIAL_SHAPES, SVG_ABSOLUTE_MARKERS, SVG_COMMAND_REG_EXP, SVG_RELATIVE_MARKERS, TEXT_STROKE_RATIO, TRANSFORMER_ANCHOR_SIZE, TRANSFORMER_BORDER_OFFSET, TRANSFORMER_MIDDLE_ANCHOR_MAX, TRANSFORMER_MIDDLE_ANCHOR_MIN, TRANSFORMER_ROTATER_BOX_SIZE, TRANSFORMER_ROTATER_BOX_SIZE_OFFSET, TRANSPARENT_RGBA, WEB_EFFECTS, WORD_DIVIDER, ZOOM_MAX, ZOOM_MAX_INPUT_NUMBER, ZOOM_MIN, ZOOM_SPEED, isDev, isTest };
